module.exports = __webpack_public_path__ + "img/Bottle.951a39be.jpg";